module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Align-left-295545df7a3205da6f500fc45fce2e49.svg";